@if (alternateNoShow) {
  <div class="popup-overlay">
    <div class="popup-box">
      <div class="warning-icon">
        <img
          src="../../../assets/icons/notification-icons/error.webp"
          alt="Error Icon"
          class="error-icon"
        />
      </div>

      <h2 class="popup-title">MSISDN is not registered with Ecocash</h2>
      <p class="popup-subtitle">
        Please login with a registered Ecocash number.
      </p>

      <!-- <label class="input-label"
      >Enter mobile number to use for this payment</label
    >

    <div class="phone-input-wrapper">
      <form #f="ngForm" [formGroup]="phoneForm">
        <div style="display: grid;">
          <ngx-intl-tel-input
            class="custom_imput"
            [inputId]="'phone-input'"
            [cssClass]="'custom'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="false"
            [searchCountryFlag]="true"
            [customPlaceholder]="'Enter Phone Number'"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name
            ]"
            (input)="validateLoginNumber($event)"
            (keydown)="blockNonNumeric($event)"
            [selectFirstCountry]="true"
            [selectedCountryISO]="CountryISO.Zimbabwe"
            [separateDialCode]="true"
            [maxLength]="10"
            [phoneValidation]="true"
            name="phone"
            formControlName="phone"
            [ngClass]="{
              'error-border':
                phoneForm.get('phone')?.errors?.invalidZimbabweMobile &&
                phoneForm.get('phone')?.touched,
              'normal-border': !(
                !phoneForm.get('phone')?.errors?.required &&
                phoneForm.get('phone')?.touched
              )
            }"
          ></ngx-intl-tel-input>
          <span
            *ngIf="
              phoneForm.get('phone')?.errors?.required &&
              phoneForm.get('phone')?.touched
            "
            style="color: red !important; padding: 5px; margin-top: 5px"
          >
            Phone Number is required!
          </span>
          <span
            *ngIf="
              !phoneForm.get('phone')?.errors?.required &&
              phoneForm.get('phone')?.errors?.invalidZimbabweMobile &&
              phoneForm.get('phone')?.touched
            "
            style="color: red !important; padding: 5px; margin-top: 5px"
          >
            Enter a valid mobile number!
          </span>
        </div>
      </form>
    </div> -->

      <div>
        <div class="action-buttons">
          <!-- <button class="btn proceed" (click)="sendOtp()">Proceed</button> -->
          <button class="btn proceed" (click)="closePopup()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
}

<!-- OTP Overlay -->

@if (showOTP) {
  <div class="popup-overlay">
    <div class="otp-popup">
      <div class="back-btn" (click)="closeOTPPopup()">← Back</div>

      <div class="phone-icon"></div>

      <h2 class="title">Phone OTP Verification</h2>
      <p class="subtitle">
        OTP sent to your mobile number ending <strong>{{ maskedPhone }}</strong>
      </p>

      <form
        method="get"
        class="digit-group login-form-control"
        autocomplete="off"
      >
        <div class="otp-box forms-block otp-container">
          <div class="otp-inputs">
            <ng-container *ngFor="let num of [1, 2, 3, 4, 5, 6]">
              <input
                [(ngModel)]="oneTimePassword['data' + num]"
                maxlength="1"
                type="text"
                id="digit-{{ num }}"
                name="digit-{{ num }}"
                [attr.data-next]="'digit-' + (num + 1)"
                [attr.data-previous]="'digit-' + (num - 1)"
                autocomplete="off"
                (keydown)="allowOnlyNumbers($event)"
                (keydown.backspace)="
                  tiggerBackspace(oneTimePassword['data' + num], 'digit-' + num)
                "
                (input)="onOtpInput($event, num); validateOtp()"
                (paste)="handlePaste($event)"
                [ngClass]="{
                  'error-border':
                    (!oneTimePassword['data' + num] && isSubmitted) ||
                    errorMessage,
                }"
              />
            </ng-container>
          </div>
          <div *ngIf="errorMessage" class="error-text-message">
            {{ errorMessage }}
          </div>
        </div>
        <div class="forms-block otp-info">
          <div class="otp-code">
            <p>Didn't receive OTP code?</p>
            <a
              href="javascript:void(0);"
              [class.disabled]="countdown > 0"
              [style.pointerEvents]="countdown > 0 ? 'none' : 'auto'"
              [ngClass]="countdown <= 0 ? 'resend-active' : ''"
              (click)="countdown === 0 && resendOtp()"
              >Resend Code</a
            >
          </div>
          <div class="otp-sec">
            <p>
              <i class="feather icon-clock"></i>
              <span>{{ displayTime }}</span> secs
            </p>
          </div>
        </div>
        <div class="reset-btn">
          <button
            class="btn w-100 button_class"
            type="button"
            (click)="validateOTP()"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
}
